<template>
  <div v-if="data">
    <form  autocomplete="off">

      <div class="row">
         <div class="col-md-12">
            <fg-select
              :options="chargetypeList"
              v-model="data.ChargeTypeId"
              :selected="data.ChargeTypeId"
              label="Encargo"
            />
          </div>

            <div class="col-md-2 text-left">
              <fg-switch @input="onChangeStatus" v-model="typeMoney" text-enabled="FATOR" text-disabled="DINHEIRO" type-bold="true" theme="default" color="red"/>
         
            </div>
           <div class="col-md-10" v-if="typeMoney == false">
          <fg-input
            class="clean"
            type="text"
            label="Dinheiro"
            placeholder="$$$"
            v-on:input="format"
            v-model="data.formattedValueCentavos"
            v-bind:readonly="readonly"
          />
           </div>

          <div class="col-md-10" v-if="typeMoney == true">

           <fg-input class="clean" type="text" label="Fator" placeholder="%" v-model="data.formattedValueFactor"
           v-bind:readonly="readonly" v-on:input="formatFactor" />
        </div>
     
        <div class="text-right">
      <btn-rounded
        v-if="!readonly"
        label="SALVAR"
        event="execute"
      />
    </div>

  </div>


    </form>
  </div>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapGetters
  } from "vuex";
  import moment from 'moment';

  export default {
    name: "nationality-form",
    components: {
    
    },

    props: {
      data: {
        type: Object,
      },
      readonly: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      },
      edit: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState({
        chargetypeList: ({
          chargetype
        }) => chargetype.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        }),
      })
    },

    methods: {
      ...mapActions(["getChargeTypeList"]),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      }),
  
      formatDate(date) {
        return moment.utc(date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')
      },

       format: function (sValue) {

        this.data.formattedValueCentavos = parseInt(("" + sValue).onlyNumber()).int2Money();
        this.data.valueCentavos = parseInt(this
          .data
          .formattedValueCentavos
          .replace("R$", "")
          .replace(",", "")
          .replaceAll(".", "")
          .replace(" ", ""));

        this.$nextTick(() => {
        });
      
      },

       formatFactor: function (sValue) {
      
          this.data.formattedValueFactor = parseInt(("" + sValue).onlyNumber()).int2Factor();

          this.data.valueFactor = parseInt(("" + sValue).onlyNumber())
          
          
       },

       onChangeStatus(){
        if(this.typeMoney == false){
          this.data.valueFactor = null
          this.data.formattedValueFactor = "0,00"
        }else{
          this.data.valueCentavos = null
          this.data.formattedValueCentavos = "R$ 0,00"
        }
       },
 

      initData(){
        this.getChargeTypeList()

      if(this.data != undefined){
          if(this.data.valueCentavos == null){
          this.typeMoney = true
        }else{
          this.typeMoney = false
        }
      }
      
        
      }

      // execute() {
      //   console.log("x")
      //   if (this.event) {
          

      //     this.$parent.$emit(this.event, this.data);
      //   }
      // },
    },

    created() {
      this.initData()

      this.$on("execute", () => {

        if(this.event){

        if(!this.data.ChargeTypeId || this.data.ChargeTypeId == ""){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Encargo é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        if(this.typeMoney == false){
        if(!this.data.formattedValueCentavos || this.data.formattedValueCentavos == "" || this.data.valueCentavos == null){
           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Comissão é obrigatório",
                position: "top center",
                type: "warn"
              });
        }
        }else{

         if(!this.data.formattedValueFactor || this.data.formattedValueFactor == "" || this.data.valueFactor == null){

           return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Fator é obrigatório",
                position: "top center",
                type: "warn"
              });
        }

        // if(this.data.formattedValueFactor.length < 9 ){
        //   return this.$notify({
        //         group: "foo",
        //         title: "Atenção",
        //         text: "Campo Fator deve conter 8 números após a virgula",
        //         position: "top center",
        //         type: "warn"
        //       });
        // }

        if(this.data.valueFactor < 1){
          return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Fator deve ser maior ou igual a 0,00000001",
                position: "top center",
                type: "warn"
              });
        }

        if(this.data.valueFactor > 100000000){
          return this.$notify({
                group: "foo",
                title: "Atenção",
                text: "Campo Fator deve ser menor ou igual a 1,00000000",
                position: "top center",
                type: "warn"
              });
        }
        }

        this.$parent.$emit(this.event, this.data);

        }
      });

    },
    data() {
      return {
        localReadonly: false,
        typeMoney: true,
      
      
      };
    },

  };
</script>

<style scoped lang="scss">

label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/ChargeForm.vue